import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { Button, Spin } from "antd";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import styles from "./Individu.module.css";
import {
  MISSATGE_SPIN_INDIVIDUS,
  TITOL_INDIVIDUS
} from "../../constantsFormularis";
import { LOCAL_STORAGE_USER } from "../../constantsObservacions";
import {
  obtenirIndividusLlistat,
  getDadesIndividuSeleccionat,
  setTitolApartat
} from "../../actions";
import {
  getUsuari,
  getPeticioIndividusEnCurs,
  getIndividusLlistat
} from "../../reducers";
import { rutaLogin, rutaIntroduccioIndividu } from "../../routes";
import IndividuTaula from "./IndividuTaula";
import ErrorBoundaryWrapper from "../commons/ErrorBoundaryWrapper";
import { calFerLogin, senseRols, tokenDecoded } from "../../utils/usuariRols";
import { NotificacioError } from "../Notification";
import { esLlistaBuida } from "../../utils/formularis";

class Individu extends Component {
  constructor(props) {
    super(props);
    this.renderitzarTaula = this.renderitzarTaula.bind(this);
  }

  componentDidMount() {
    this.props.setTitolApartat(TITOL_INDIVIDUS);
    this.obtenirIndividus();
  }

  obtenirIndividus = () => {
    this.props
      .obtenirIndividusLlistat()
      .then(dades => {
        if (dades.error || (dades.payload && dades.payload.message)) {
          return NotificacioError(
            "Avís llistat d'individus",
            dades.error && dades.error.message
              ? dades.error.message
              : dades.payload.message
          );
        }
        if (esLlistaBuida(dades.payload, null)) {
          //Segon param null ja que dades.payload no té propietats en cas d'individus'
          return NotificacioError("Avís", "No s'han trobat individus.");
        }
      })
      .catch(error => {
        return NotificacioError(
          error.titol ? error.titol : "Error",
          error.message ? error.message : error
        );
      });
  };

  renderitzarTaula() {
    const { individus, getDadesIndividuSeleccionat, history } = this.props;
    return (
      <IndividuTaula
        individus={individus}
        history={history}
        getDadesIndividuSeleccionat={getDadesIndividuSeleccionat}
      />
    );
  }

  recuperarUsuari = usuari => {
    if (!calFerLogin(usuari)) {
      return this.tokenTrobat(usuari);
    } else {
      const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER));
      if (token) {
        return this.tokenTrobat(tokenDecoded(token.token));
      } else {
        return <Redirect to={rutaLogin} />;
      }
    }
  };

  tokenTrobat = usuari => {
    const { isPeticioEnCurs, individus } = this.props;

    if (senseRols(usuari)) {
      return <Redirect to={rutaLogin} />;
    }
    const hihaDades =
      individus && Array.isArray(individus) && individus.length > 0;

    return (
      <Spin
        spinning={isPeticioEnCurs}
        tip={MISSATGE_SPIN_INDIVIDUS}
        delay={300}
      >
        <div className={styles.individuBotoInserir}>
          <Link to={rutaIntroduccioIndividu}>
            <Button type="primary" icon="plus-circle-o">
              Individu
            </Button>
          </Link>
        </div>
        {hihaDades ? (
          <div className={styles.individu}>{this.renderitzarTaula()}</div>
        ) : null}
      </Spin>
    );
  };

  render() {
    return this.recuperarUsuari(this.props.usuari);
  }
}

Individu.propTypes = {
  individus: PropTypes.array,
  obtenirIndividusLlistat: PropTypes.func,
  isPeticioEnCurs: PropTypes.bool,
  getDadesIndividuSeleccionat: PropTypes.func,
  history: PropTypes.object,
  setTitolApartat: PropTypes.func.isRequired,
  usuari: PropTypes.object
};

const mapStateToProps = state => {
  return {
    isPeticioEnCurs: getPeticioIndividusEnCurs(state),
    individus: getIndividusLlistat(state),
    usuari: getUsuari(state)
  };
};

const mapDispatchToProps = {
  obtenirIndividusLlistat,
  getDadesIndividuSeleccionat,
  setTitolApartat
};

export default ErrorBoundaryWrapper(
  connect(mapStateToProps, mapDispatchToProps)(Individu)
);
